import React from "react";
import CustomStepper from "../../CommonComponents/Stepper/CustomStepper";
import { vendorOnboardingSteppers } from "../../Utils/helper";
import PanGstDetails from "./OnboardingForms/PanGstDetails";
import CompanyDetails from "./OnboardingForms/CompanyDetails";
import BankDetails from "./OnboardingForms/BankDetails";
import ServiceDetails from "./OnboardingForms/ServiceDetails";
import Documents from "./OnboardingForms/Documents";
import { useEffect } from "react";

function VendorOnboarding() {
  useEffect(() => {
    window?.scroll(0, 0);
  }, []);

  return (
    <CustomStepper
      stepperDetails={vendorOnboardingSteppers}
      components={{
        PanGstDetails,
        CompanyDetails,
        BankDetails,
        ServiceDetails,
        Documents,
      }}
    />
  );
}

export default VendorOnboarding;
